import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, CustomInput, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import { TAG_LIST_GET } from '../../../../app/redux/actions/tutors';
import TagBadge from '../../TagBadge';
import { TagsContainer } from './style';

export const ModalTagsId = 'ModalTags';

const ModalTags = ({
  mediaIsPhone,
  isOpen,
  id,
  tags,
  addedTags,
  setAddedTags,
  getTags,
  modalClose,
}) => {
  const scrollableAreaRef = useRef(null);
  const [search, setSearch] = useState('');
  const [newTags, setNewTags] = useState(addedTags);

  useEffect(() => {
    if (id === ModalTagsId) {
      if (isOpen) getTags();
      setNewTags(addedTags || []);
      setSearch('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const addTag = (tag) => {
    setNewTags([...newTags, tag]);
  };

  return (
    <Modal
      title="Aggiungi TAG"
      modalId={ModalTagsId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <ScrollableArea
        ref={scrollableAreaRef}
        style={{
          minHeight: '40vh',
          maxWidth: '768px',
          minWidth: 'min(var(--full-width), 768px)',
        }}
      >
        <CustomInput
          size="m"
          placeholder="Cerca TAG..."
          isSearch
          className="mb-4"
          icon="search-sm"
          isClearable
          value={search}
          onChange={(value) => setSearch(value)}
          onClickIcon={() => getTags({ search_text: search })}
          onKeyPress={(event) => {
            if (event.key === 'Enter') getTags({ search_text: search });
          }}
        />
        {newTags?.length > 0 && (
          <TagsContainer>
            {(newTags || []).map((t, i) => (
              <TagBadge
                key={`added-tag-${i}`}
                item={t}
                isActive
                onClick={() => {
                  const tempTags = [...newTags];
                  tempTags.splice(i, 1);
                  setNewTags(tempTags);
                }}
              />
            ))}
          </TagsContainer>
        )}
        {tags?.length > 0 && (
          <>
            <Text type="b3" mb={16}>
              Tag suggeriti in base all’area tematica selezionata:
            </Text>
            <TagsContainer>
              {tags
                .filter((t) => newTags?.findIndex((nt) => nt.id === t.id) < 0)
                .map((t, i) => (
                  <TagBadge
                    key={`tag-${i}`}
                    item={t}
                    onClick={() => addTag(t)}
                  />
                ))}
            </TagsContainer>
          </>
        )}
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        <CTA
          type="primary"
          btnText="Salva"
          fullsize={mediaIsPhone}
          onClick={() => {
            setAddedTags(newTags);
            modalClose();
          }}
        />
      </Footer>
    </Modal>
  );
};

ModalTags.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  addedTags: PropTypes.array,
  setAddedTags: PropTypes.func,
  // state
  isOpen: PropTypes.bool,
  id: PropTypes.string,
  tags: PropTypes.array,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  getTags: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { isOpen, id } = state.app.modal;
      const { tags } = state.tutors;
      return { tags, isOpen, id };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getTags: (filters) => dispatch({ type: TAG_LIST_GET._REQUEST, filters }),
    })
  ),
  withMediaQueries
)(ModalTags);
